import { Formik } from 'formik';

import { isMobile } from 'hooks';
import { ButtonColors, PaymentMethodType } from 'types';
import {
  Row,
  Col,
  Icon,
  Button,
  DialogType,
  InputField,
  ButtonTypes,
  CommonStyles,
} from 'components';

import { useRemainderCart } from '../hooks';
import { TemplateDialog } from '../template-dialog';
import { FullAmountButton } from '../full-amount-button';

import { CheckProps, CheckFormValues } from './types';
import { initialValues, getValidationSchema } from './config';

export const Check = ({ amount, onAddPaymentMethod }: CheckProps) => {
  const mobile = isMobile();
  const { remainder, isBalanceZero } = useRemainderCart(amount);

  return (
    <TemplateDialog title="Check" icon={<Icon.CheckCard />}>
      {(close, _, ButtonWrap) => (
        <Formik<CheckFormValues>
          initialValues={initialValues}
          validationSchema={getValidationSchema(remainder)}
          onSubmit={(values) => {
            console.log('[Checkout] added check in payment method', values);

            const checkAmount = +values.amount;
            const type = PaymentMethodType.Check;
            onAddPaymentMethod({
              ...values,
              type,
              amount: checkAmount,
              totalAmount: checkAmount,
              id: `${values.amount}-${type}`,
              checkNumber: +values.checkNumber,
            });
            close();
          }}
        >
          {({ dirty, isSubmitting }) => (
            <CommonStyles.Form>
              <Row>
                <Col>
                  <InputField
                    number
                    decimal
                    name="amount"
                    label="Amount"
                    placeholder="Amount"
                  />

                  <FullAmountButton<CheckFormValues>
                    remainder={remainder}
                    isBalanceZero={isBalanceZero}
                  />
                </Col>
              </Row>

              <Row>
                <Col>
                  <InputField
                    name="holderName"
                    label="Check holder name"
                    placeholder="Check holder name"
                  />
                </Col>
              </Row>

              <Row>
                <Col col={6}>
                  <InputField
                    number
                    name="checkNumber"
                    label="Check number"
                    placeholder="Check number"
                  />
                </Col>
                <Col col={6}>
                  <InputField
                    type="tel"
                    name="phoneNumber"
                    label="Phone number"
                    placeholder="Phone number"
                  />
                </Col>
              </Row>

              <Row>
                <Col>
                  <InputField
                    name="driverLicense"
                    label="Driver license/ID"
                    placeholder="Driver license/ID"
                  />
                </Col>
              </Row>

              <ButtonWrap type={DialogType.Plain}>
                <Button
                  text="Cancel"
                  onClick={close}
                  fullWidth={mobile}
                  colorType={ButtonColors.LightBlue}
                />
                <Button
                  text="Confirm"
                  fullWidth={mobile}
                  type={ButtonTypes.Submit}
                  disabled={!dirty || isSubmitting}
                />
              </ButtonWrap>
            </CommonStyles.Form>
          )}
        </Formik>
      )}
    </TemplateDialog>
  );
};
